<template>
  <nav class="nav-container flex justify-between items-center p-2 shadow-md sticky top-0 z-50 font-serif">
    <div class="flex items-center">
      <img src="/image/im8.png" alt="Logo HotelBook" class="h-16 w-16 mr-2">
      <h1 class="text-1xl font-bold text-white">University | StudentGate</h1>
    </div>

    <ul class="flex space-x-6 items-center text-white">
      <router-link to="/dashboard" class="hover:text-blue-400 text-1xl transition duration-300">Accueil</router-link>
      <router-link to="/cours" class="hover:text-blue-400 text-1xl transition duration-300">Cours</router-link>
      <router-link to="/calendar" class="hover:text-blue-400 text-1xl transition duration-300">Calendrier</router-link>
      <router-link to="/eval" class="hover:text-blue-400 text-1xl transition duration-300">Évaluation</router-link>

      <li class="relative" ref="menuRef">
        <div class="flex items-center cursor-pointer" @click="toggleDropdown">
          <div class="rounded-full overflow-hidden w-14 h-14 border-2 border-white">
            <img v-if="user" :src="getImageUrl(user.image)" alt="User Image" class="w-full h-full object-cover" />
          </div>
        </div>

        <div
          v-if="dropdownVisible && user"
          class="absolute top-full mt-2 right-0 w-64 bg-white border border-gray-300 rounded-lg shadow-lg p-4 z-50"
        >
          <p class="text-blue-900 text-center">Bienvenue</p>
          <div class="flex items-center mb-3">
            <img src="/image/im18.png" alt="Icon" class="h-8 w-8 mr-2">
            <p class="text-gray-800 font-semibold">{{ user.surname }} {{ user.name }}</p>
          </div>
          <button
            @click="logout"
            class="w-full px-4 py-2 text-blue-900 bg-gray-100 rounded hover:bg-blue-900 hover:text-white transition duration-300"
          >
            Se déconnecter
          </button>
        </div>
      </li>
    </ul>
  </nav>

</template>

<script>
 
import axios from 'axios';

export default {
  name: 'DashboardView,Notifications',
  data() {
    return {
     
      user: null,
      dropdownVisible: false,
       
    };
  },

  mounted() {
    this.fetchUser();
    document.addEventListener('click', this.closeDropdownOnClickOutside);
},

beforeUnmount() {
  document.removeEventListener('click', this.closeDropdownOnClickOutside);
  },

  methods: {

     

    
 





    fetchUser() {
      axios.get('https://mida-back.onrender.com/api/user', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then((res) => {
        this.user = res.data;
      })
      .catch((error) => {
        console.error('Erreur lors du fetch de l’utilisateur connecté :', error);
      });
    },

    toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
  },
  closeDropdownOnClickOutside(event) {
    const menu = this.$refs.menuRef;
    if (menu && !menu.contains(event.target)) {
      this.dropdownVisible = false;
    }
  },

    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      this.$router.push('/');
    },

    getImageUrl(path) {
      return path ? `https://mida-back.onrender.com/${path}` : '/image/default-users.jpg';
    }
  }
};
</script>

  
  <style scoped>
 
.nav-container {
  background-color: #163767;
}
  
  </style>